import UpdateIcon from "@mui/icons-material/Update";
import type { Duration } from "dayjs/plugin/duration";

import { LabelValue } from "../../components/LabelValue";
import { useNextTranslation } from "../../hooks";
import { formatDurationToTextAlternative } from "../../utils/formatters/formatDuration";

export type ProductAdvanceArrivalDurationMetaDataProps = {
    duration?: Duration;
};

export function ProductAdvanceArrivalDurationMetaData({ duration }: ProductAdvanceArrivalDurationMetaDataProps) {
    const [t] = useNextTranslation("product");
    const noLimitLabel = t("label.noLimit");
    const beforeStartTimeLabel = t("label.beforeStartTime");
    const label = t("label.advancedArrival");
    const durationFormattedText = !duration
        ? noLimitLabel
        : `${formatDurationToTextAlternative(duration)} ${beforeStartTimeLabel}`;
    return (
        <LabelValue label={label} Icon={UpdateIcon}>
            {durationFormattedText}
        </LabelValue>
    );
}
